/**
 * PaginationBar styles — footer chrome.
 * Mobile/tablet (< md): stack summary above controls.
 * Laptop+ (md): summary left, controls flush right (no utility conflicts).
 */

import { cn } from "@/utils/cn";

export function getPaginationBarClassName(className?: string): string {
  return cn(
    "shrink-0 flex flex-col gap-3",
    "md:flex-row md:items-center md:justify-between md:gap-4",
    "px-4 sm:px-5 py-3",
    "border-t border-light-lila/40 bg-light",
    className
  );
}

export function getPaginationBarMetaClassName(): string {
  return "flex w-full shrink-0 flex-wrap items-center gap-2 md:w-auto md:gap-3";
}

export function getPaginationBarSummaryClassName(): string {
  return "tabular-nums";
}

/** Wrapper pushes controls to the right on md+ without fighting Pagination nav utilities. */
export function getPaginationBarControlsWrapClassName(): string {
  return "w-full shrink-0 md:ml-auto md:w-auto";
}

export function getPaginationBarControlsClassName(): string {
  return "mx-0 w-full justify-start md:w-auto md:justify-end";
}

export function getPaginationBarPageSizeClassName(): string {
  return cn(
    "border border-light-lila/60 rounded-md bg-light px-2 py-1",
    "text-xs font-body text-dark-invirtus",
    "focus:outline-none focus:ring-1 focus:ring-purple/40 focus:border-transparent"
  );
}
